export const PROJECT_TYPES = [
  { value: 'apartments', label: 'Apartments' },
  { value: 'villas', label: 'Villas' },
  { value: 'plots', label: 'Plots' },
  { value: 'township', label: 'Township (Mixed)' }
];

export const PROJECT_STAGES = [
  { value: 'pre_launch', label: 'Pre-launch' },
  { value: 'soft_launch', label: 'Soft Launch' },
  { value: 'launch', label: 'Launch' },
  { value: 'under_construction', label: 'Under Construction' },
  { value: 'near_possession', label: 'Near Possession' },
  { value: 'delivered', label: 'Delivered' }
];

export const ALLOCATION_MODES = [
  { value: 'first_come_first_serve', label: 'First Come First Serve' },
  { value: 'controlled_release', label: 'Controlled Release' },
  { value: 'lottery_based', label: 'Lottery Based' }
];

export const PRICE_MASKING_MODES = [
  { value: 'full_price', label: 'Full Price' },
  { value: 'range_only', label: 'Range Only' },
  { value: 'contact_sales', label: 'Contact Sales' }
];

export const getStageColor = (stage) => {
  const colors = {
    pre_launch: 'bg-purple-100 text-purple-700 dark:bg-purple-950 dark:text-purple-400',
    soft_launch: 'bg-blue-100 text-blue-700 dark:bg-blue-950 dark:text-blue-400',
    launch: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-950 dark:text-emerald-400',
    under_construction: 'bg-amber-100 text-amber-700 dark:bg-amber-950 dark:text-amber-400',
    near_possession: 'bg-cyan-100 text-cyan-700 dark:bg-cyan-950 dark:text-cyan-400',
    delivered: 'bg-green-100 text-green-700 dark:bg-green-950 dark:text-green-400'
  };
  return colors[stage] || 'bg-muted text-muted-foreground';
};

export const DEFAULT_FORM_DATA = {
  name: '',
  code: '',
  location: '',
  description: '',
  developer_id: 'dev_default',
  image_url: '',
  project_type: 'apartments',
  project_stage: 'pre_launch',
  rera_registered: false,
  rera_number: '',
  sales_start_date: '',
  expected_completion_date: '',
  inventory_behavior: {
    default_soft_block_hours: 24,
    allow_cp_soft_block: true,
    allow_website_visibility: false
  },
  channel_strategy: {
    enable_channel_partners: true,
    enable_website_booking: false,
    internal_sales_only: false
  },
  pricing_visibility: {
    show_to_sales: true,
    show_to_cp: true,
    show_to_website: false,
    masking_mode: 'full_price'
  },
  allocation_mode: 'first_come_first_serve',
  linked_crm: '',
  crm_project_id: ''
};
